<template>
  <div class="flux_export">
    <switchComponent :value="all" ref="showall" @input="() => showAllChange()" :label="i18nJS.flux_exports.show_deleted" />
    <table class="table table-hover" v-if="fluxExports.length > 0">
      <thead>
        <tr class="heading">
          <th>{{ i18nJS.anno }}</th>
          <th>{{ i18nJS.period }}</th>
          <th>{{ i18nJS.bu }}</th>
          <th>{{ i18nJS.status }}</th>
          <th>{{ i18nJS.flux_exports.row_count }}</th>
          <th>{{ i18nJS.flux_exports.updated_who }}</th>
          <th>{{ i18nJS.flux_exports.dl }}</th>
        </tr>
        <tr class="heading filters">
          <th>
            <v-select2 v-model="filter.year" :options-list="yearValues" :data-allow-clear="true" id="yearFilterSelect"> </v-select2>
          </th>
          <th>
            <v-select2 v-model="filter.period" :options-list="periodValues" :data-allow-clear="true" id="periodFilterSelect"> </v-select2>
          </th>
          <th>
            <v-select2 v-model="filter.bu" :options-list="buValues" :data-allow-clear="true" id="buFilterSelect"> </v-select2>
          </th>
          <th>
            <v-select2 v-model="filter.status" :options-list="statusValues" :data-allow-clear="true" id="statusFilterSelect"> </v-select2>
          </th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="fluxExport in filteredFluxExports">
          <tr
            class="flusso"
            :class="{ annullato: fluxExport.status == 4 }"
            :id="`row-${fluxExport.id}`"
            :key="fluxExport.id"
            v-if="!fluxExport._blank"
            :data-activity-relation="fluxExport.flux_export_id"
          >
            <td>
              <p>{{ fluxExport.anno }}</p>
            </td>
            <td>
              <p>{{ fluxExport.periodo }}</p>
            </td>
            <td>
              <span>{{ fluxExport.codstr }}</span>
              <span>({{ fluxExport.bu_fname }})</span>
            </td>
            <td>
              <div :class="{ red: fluxExport.isCancelled, yellow: fluxExport.isDeleted, green: fluxExport.isActive }">
                {{ stato(fluxExport.status) }}
              </div>
            </td>
            <td>
              <ul class="inline text-uppercase">
                <template v-for="(counter, flux_record) in fluxExport.row_counts">
                  <li :key="counter">
                    {{ flux_record.replace(/s$/, '') }}: <strong>{{ counter }}</strong>
                  </li>
                </template>
              </ul>
            </td>
            <td>
              <user-media :fullname="fluxExport.updator_name" :datetime="fluxExport.updated_at" :img="fluxExport.updator_avatar" />
            </td>
            <td>
              <a v-if="fluxExport.file_url != null" :href="decodeURI(fluxExport.file_url)"><i class="fa-light fa-download" /></a>
              <a :id="`undo-trash-${fluxExport.id}`" v-if="superUser && fluxExport.status == 4" @click="restore(fluxExport.id)"
                ><i class="fa-light fa-trash-undo"
              /></a>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <div class="box_msg alert alert-info" v-if="fluxExports.length == 0">
      {{ i18nJS.flux_exports.no_record }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Route } from '../../route';
import switchComponent from '../switchComponent';
import userMedia from '../userMedia';
import vSelect2 from '../vSelect2';

export default {
  name: 'flux-exports-index',
  components: {
    switchComponent,
    userMedia,
    vSelect2,
  },
  data() {
    return {
      all: false,
      filter: { bu: null, year: null, period: null, status: 1 },
      fluxExports: [],
      superUser: false,
    };
  },
  computed: {
    filteredFluxExports() {
      if (!this.filter.year && !this.filter.period && !this.filter.bu && !this.filter.status) return this.fluxExports;

      return this.fluxExports.filter(this.filterFe);
    },
    buValues() {
      let array = this.fluxExports.map((fe) => [`${fe.codstr} (${fe.bu_fname})`, fe.codstr]);
      let set = new Set(array.map(JSON.stringify));
      array = Array.from(set).map(JSON.parse);
      return array.sort();
    },
    yearValues() {
      return this.fluxExports
        .map((fe) => fe.anno)
        .filter((value, index, self) => self.indexOf(value) === index)
        .map((year) => [year, year])
        .sort()
        .reverse();
    },
    periodValues() {
      return this.fluxExports
        .map((fe) => fe.periodo)
        .filter((value, index, self) => self.indexOf(value) === index)
        .map((period) => [period, period])
        .sort();
    },
    statusValues() {
      return [
        ['Esportato', 1],
        ['Cancellato', 2],
        ['Annullato', 3],
      ];
    },
    i18nJS() {
      return window.i18nJS;
    },
  },
  methods: {
    filteredBu() {
      if (this.buValues && this.buValues.length == 1) {
        this.filter.bu = this.buValues[0][1];
      }
      return this.filter.bu;
    },
    filteredYear() {
      if (this.yearValues && this.yearValues.length == 1) {
        this.filter.year = this.yearValues[0][1];
      }
      return this.filter.year;
    },
    filteredPeriod() {
      if (this.periodValues && this.periodValues.length == 1) {
        this.filter.period = this.periodValues[0][1];
      }
      return this.filter.period;
    },
    showAllChange() {
      const url = !this.$refs.showall.value ? `${window.location.href}&all` : window.location.href.replace(/&?all=?/, '');
      Loader.show();
      window.location = url;
    },
    filterFe(flux_export) {
      return (
        (!this.filter.year || this.filter.year == flux_export.anno) &&
        (!this.filter.period || this.filter.period == flux_export.periodo) &&
        (!this.filter.status || this.filter.status == flux_export.status) &&
        (!this.filter.bu || this.filter.bu == flux_export.codstr)
      );
    },
    restore(fe_id) {
      axios({
        method: 'put',
        url: `${Route.FLUX_EXPORTS}/${fe_id}.json`,
        data: { status: 1 },
        headers: {
          'Content-type': 'application/json',
          'X-CSRF-Token': $.rails.csrfToken(),
        },
      })
        .then((res) => {
          $(`#row-${fe_id}`).removeClass('annullato');
          $(`#undo-trash-${fe_id}`).remove();
        })
        .catch((err) => {
          var msg = `${i18nJS.errors.critical_error}: ${err.message}`;
          if (err.response.status === 401) {
            msg = i18nJS.access_denied;
          }
          Utils.appendToFlash('error', msg);
        });
    },
    stato(status) {
      if (status == 1) {
        return 'esportato';
      } else if (status == 2) {
        return 'cancellato';
      } else if (status == 4) {
        return 'annullato';
      }
    },
  },
  mounted() {
    this.all = /^.*&?all=?/.test(window.location.href);
    this.filter.status = this.all ? undefined : 1;
    this.superUser = window.config.user.super;
    $(document).ready(() => {
      this.fluxExports = $('#flux-exports').data('flux-exports');
      this.filter.year = this.filter.year || this.filteredYear();
      this.filter.period = this.filter.period || this.filteredPeriod();
      this.filter.bu = this.filter.bu || this.filteredBu();
    });
  },
};
</script>

<style lang="scss" scoped>
tr.annullato {
  background-color: lightpink;
}
</style>
